<template lang="pug">
div(class="d-flex flex-column justify-content-between h-100 main-container" style="width:15%")
    div(class="d-flex flex-column justify-content-start align-items-center mx-auto h-75" style="width:100%;")
        div(class="d-flex justify-content-center align-items-center image-container w-100 ")
            b-img(:src="DSG_logo", alt="DSG Logo" class="img-logo" width="150px")
        div(class="d-flex flex-column justify-content-start align-items-center px-4 py-2" style="height:fit-content;").w-100
            b-button(v-for="item in navItems" :key="item.name" :to="item.url" variant="primary" class="w-100 mb-2"
                :class="{'active': $route.path === item.url, 'not-active': $route.path !== item.url}" )
                | {{ item.name }}
    div(class="d-flex flex-column justify-content-end align-items-center mx-auto h-25 py-2" style="width:80%;")
        //- b-button.w-100(variant="danger") Logout
        
            
                


</template>

<script>
import DSG_logo from '@/assets/Images/DSG_logo.png';
    export default {
        data(){
            return {
                DSG_logo,
                btnClickedColor: "#50276b",
                navItems:[
                    {name: "Home",url:"/"},
                    {name: "Announcements",url:"/announcements"},
                    // {name: "Messages",url:"/chat"},
                    {name: "Events",url:"/events"},
                    // {name: "Add Events",url:"/addevent"},
                    

                ]
            }
        },
        
    }
</script>

<style lang="scss" scoped>
.main-container{
    background-color: #50276b;
}
.image-container{
    width: 100%;
    height: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
}
.main-container ::v-deep .btn {
    border-radius: 8px;
    font-weight: 600;
    transition: background-color 0.2s ease, color 0.2s ease;
}
.active {
    background-color: #3e1f5b !important;
    border-color: #3e1f5b !important;
    color: white !important;
    outline: none;
    box-shadow: inset 4px 0 0 #b892e0;
}
.not-active{
    background-color: transparent !important;
    color: white !important;
    outline: none;
    border: none !important;
}
.not-active:hover{
    background-color: #3e1f5b !important;
}

</style>